<section class="admin-page ct-page dashboard">
  <div class="admin-dashboard-header">
    <p>{{ 'dashboard.subtitle' | t }}</p>
  </div>

  <div class="admin-dashboard-cards">
    @for (card of cards(); track card.path) {
      <a class="admin-dashboard-card ct-card" [routerLink]="card.path">
        <h3>{{ card.titleKey | t }}</h3>
        <p>{{ card.descKey | t }}</p>
      </a>
    }
  </div>
</section>
